import { Box, Button, Container, Fade, Tooltip, Typography, useTheme } from "@mui/material";
import { useLoaderData } from "react-router-dom";
import { AutoAwesome, FormatQuote, WorkHistory } from "@mui/icons-material";
import { useState } from "react";
import createSliderStyles from "../styles/slider.styles";
import Testimonial from "../reusable-components/testimonial";
import TestimonialModal from "../reusable-components/testimonial-modal";
import Experience from "../reusable-components/Experience";
import CommonDialog from "../reusable-components/common-dialog";
import { summarizeContent } from "../utils/summarizeContent";
import { sparkleStyles } from "../styles/common.styles";

function Work() {
    const data = useLoaderData();
    const { testimonials } = data || { testimonials: [] };
    const [summaryLoading, setSummaryLoading] = useState(false);
    const [summaryResult, setSummaryResult] = useState('');
    const [summaryOpen, setSummaryOpen] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [selectedTestimonialIndex, setSelectedTestimonialIndex] = useState(0);
    const theme = useTheme();
    const styles = createSliderStyles(theme);

    const handleCloseModal = () => setOpenModal(false);
    
    const handleOpenModal = (index) => {
        setSelectedTestimonialIndex(index);
        setOpenModal(true);
    };

    const handleSummarize = async () => {
        setSummaryLoading(true);
        try {
          const result = await summarizeContent(
            `Can you summarize these testimonials which have been given to Satish: ${testimonials.map(testimonial => testimonial.description).join(', ')}`
          );
          setSummaryResult(result);
          setSummaryOpen(true);
        } catch (error) {
          console.error('Error getting summary:', error);
        } finally {
          setSummaryLoading(false);
        }
      };

    return (
        <Container maxWidth="lg" sx={{ py: 6 }}>
            <Fade in timeout={800}>
                <Box>
                    <Box sx={styles.testimonialContainer}>
                        <Box sx={styles.titleContainer}>
                            <FormatQuote color="primary" sx={styles.titleIcon} />
                            <Typography variant="h3" component="h2" fontWeight="500">
                                Testimonials
                            </Typography>
                            <Tooltip title="AI Summary of testimonials">
                                <Button onClick={handleSummarize} disabled={summaryLoading}>
                                    {summaryLoading ? <AutoAwesome sx={sparkleStyles} /> : <AutoAwesome />}
                                </Button>
                            </Tooltip>
                        </Box>
                        
                        <Testimonial 
                            testimonials={testimonials} 
                            styles={styles} 
                            openModal={handleOpenModal} 
                        />
                    </Box>

                    <TestimonialModal
                        open={openModal}
                        onClose={handleCloseModal}
                        testimonial={testimonials[selectedTestimonialIndex]}
                    />

                    <Box sx={{ mt: 8 }}>
                        <Box sx={styles.titleContainer}>
                            <WorkHistory color="primary" sx={styles.titleIcon} />
                            <Typography variant="h3" component="h2" fontWeight="500">
                                Experience
                            </Typography>
                        </Box>
                        <Experience />
                    </Box>
                </Box>
            </Fade>
            <CommonDialog 
                open={summaryOpen}
                onClose={() => setSummaryOpen(false)}
                title="Testimonial Summary"
                content={summaryResult}
                showTTSButton={true}
                isMarkdown
            />
        </Container>
    );
}

export default Work;